// extracted by mini-css-extract-plugin
export var displayNone = "_uh-6";
export var imgContainer = "_uh-2";
export var overflowHidden = "_uh-3";
export var productInfoCardButtonContainer = "_uh-5";
export var productTitleText = "_uh-4";
export var rightArrow = "_uh-1";
export var rightArrowContainer = "_uh-0";